export default "__VITE_ASSET__4188bb78__"